(function () {
  if (window.__brandShippingReady) {
    if (window.initBrandShipping) window.initBrandShipping();
    return;
  }
  window.__brandShippingReady = true;

  var PINCODE_URL = 'https://phpstack-976052-3454881.cloudwaysapps.com/api/get-pincode-list-page';
  var RATE_URL = 'https://phpstack-976052-3454881.cloudwaysapps.com/api/get-shipping-au';

  function lineQuantity(root) {
    var line = root.closest('.cart-product-item');
    if (!line) return null;
    var cartQtyInput = line.querySelector('.quantity-input');
    var cartQty = cartQtyInput ? parseInt(cartQtyInput.value, 10) : parseInt(root.getAttribute('data-qty'), 10);
    if (!isNaN(cartQty) && cartQty > 0) return cartQty;
    return 1;
  }

  function bindAg(root) {
    if (!root || root.dataset.agBound === '1') return;
    var input = root.querySelector('.ag-equipment-shipping__input');
    var suggest = root.querySelector('.ag-equipment-shipping__suggest');
    var errorEl = root.querySelector('.ag-equipment-shipping__error');
    var resultEl = root.querySelector('.ag-equipment-shipping__result');
    var submitBtn = root.querySelector('.ag-equipment-shipping__button');
    if (!input || !suggest || !errorEl || !resultEl || !submitBtn) return;
    root.dataset.agBound = '1';

    var debounceTimer = null;

    function setLoading(on) {
      submitBtn.classList.toggle('is-loading', on);
      submitBtn.disabled = on;
    }

    function showError(msg) {
      errorEl.hidden = !msg;
      errorEl.textContent = msg || '';
    }

    function zipFields() {
      return {
        zip: root.querySelector('.ag-ship-zip'),
        city: root.querySelector('.ag-ship-city'),
        province: root.querySelector('.ag-ship-province')
      };
    }

    function getQuantity() {
      var cartQty = lineQuantity(root);
      if (cartQty !== null) return cartQty;
      var qty = document.querySelector('.quantity-input');
      var n = qty ? parseInt(qty.value, 10) : 1;
      return isNaN(n) || n < 1 ? 1 : n;
    }

    function warehouseName(code) {
      if (code === 'QLD') return 'Queensland';
      if (code === 'NSW') return 'NSW';
      return 'Victoria';
    }

    function formatPrice(value) {
      var n = Number(value);
      if (isNaN(n)) return '';
      if (Number.isInteger(n)) n = n / 100;
      return n.toFixed(2);
    }

    function isNorthline(item) {
      if (!item) return false;
      var text = [
        item.service_name,
        item.service_code,
        item.description,
        item.carrier,
        item.warehouse
      ].join(' ').toLowerCase();
      return text.indexOf('northline') !== -1;
    }

    function renderRates(rates) {
      rates = (rates || []).filter(function (item) { return item && !isNorthline(item); });
      if (!rates.length) {
        resultEl.innerHTML = '<p>Sorry, no shipping rate is found for your location.<br>Please contact us for a delivery quote.</p>';
        return;
      }
      var html = '';
      rates.forEach(function (item) {
        if (item.service_name === 'Free Shipping!') {
          html += "<p><b>Sorry, we don't have a shipping rate to your area.</b></p>";
          return;
        }
        html += '<p class="ag-equipment-shipping__rate">Standard Kerbside Delivery — <span>ETA 2-7 business days from ' +
          warehouseName(item.warehouse) + '</span><br><strong>' + (item.service_name || 'Delivery') +
          ' $' + formatPrice(item.total_price) + '</strong></p>';
      });
      resultEl.innerHTML = html || '<p>Sorry, no shipping rate is found for your location.</p>';
    }

    function withoutNorthline(list) {
      if (!Array.isArray(list)) return [];
      return list.filter(function (item) { return item && !isNorthline(item); });
    }

    function normalizeRates(payload) {
      if (!payload) return [];
      var data = payload;
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch (e) { return []; }
      }
      if (data.data != null) data = data.data;
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch (e) { return []; }
      }
      if (data && Array.isArray(data.rates)) return withoutNorthline(data.rates);
      if (Array.isArray(data) && data[0] && data[0].service_name) return withoutNorthline(data);
      if (Array.isArray(data) && Array.isArray(data[0])) {
        return withoutNorthline(data.reduce(function (acc, group) {
          return acc.concat(group);
        }, []));
      }
      if (payload && Array.isArray(payload.rates)) return withoutNorthline(payload.rates);
      return [];
    }

    function productPayload() {
      var fields = zipFields();
      return {
        zipcode: fields.zip.value || '',
        country: 'Australia',
        province: fields.province.value || '',
        city: fields.city.value || '',
        product_id: Number(root.getAttribute('data-product-id')),
        variant_id: Number(root.getAttribute('data-variant-id')),
        quantity: getQuantity(),
        grams: Number(root.getAttribute('data-grams') || 0),
        sku: root.getAttribute('data-sku') || ''
      };
    }

    function estimateShipping() {
      var zip = zipFields().zip.value;
      if (!zip) {
        showError('Enter a valid suburb or postcode');
        return;
      }
      showError('');
      setLoading(true);
      var payload = productPayload();
      fetch(RATE_URL, {
        method: 'POST',
        mode: 'cors',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) { return res.text(); })
        .then(function (text) {
          var json = null;
          try { json = JSON.parse(text); } catch (e) { json = null; }
          if (!json || json.success === false) {
            renderRates([]);
            return;
          }
          renderRates(normalizeRates(json));
        })
        .catch(function () {
          renderRates([]);
        })
        .finally(function () {
          setLoading(false);
        });
    }

    function hideSuggest() {
      suggest.classList.remove('is-open');
      suggest.innerHTML = '';
    }

    function itemLabel(item) {
      if (typeof item === 'string') return item;
      return item.label || item.value || item.name || item.text || '';
    }

    function applyLocation(label) {
      var text = String(label || '').trim();
      var parts = text.split(',');
      var zip = parts[parts.length - 1].trim();
      var postcodeMatch = text.match(/\b(\d{4})\b/);
      if (!/^\d{4}$/.test(zip) && postcodeMatch) zip = postcodeMatch[1];
      var province = parts.length > 1 ? parts[1].trim() : '';
      var city = parts[0] ? parts[0].trim() : '';
      input.value = text;
      var fields = zipFields();
      fields.zip.value = zip;
      fields.province.value = province;
      fields.city.value = city;
      hideSuggest();
    }

    function resolveAndEstimate(value) {
      var postcodeMatch = String(value).match(/\b(\d{4})\b/);
      if (postcodeMatch) {
        applyLocation(value);
        estimateShipping();
        return;
      }
      setLoading(true);
      fetch(PINCODE_URL + '?term=' + encodeURIComponent(value))
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var list = [];
          if (data && Array.isArray(data.pincodes)) list = data.pincodes;
          else if (data && Array.isArray(data.data)) list = data.data;
          else if (Array.isArray(data)) list = data;
          if (list.length) {
            applyLocation(itemLabel(list[0]));
            estimateShipping();
            return;
          }
          setLoading(false);
          showError('Enter a valid suburb or postcode');
        })
        .catch(function () {
          setLoading(false);
          showError('Enter a valid suburb or postcode');
        });
    }

    function searchPincodes(term) {
      fetch(PINCODE_URL + '?term=' + encodeURIComponent(term))
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var list = [];
          if (data && Array.isArray(data.pincodes)) list = data.pincodes;
          else if (data && Array.isArray(data.data)) list = data.data;
          else if (Array.isArray(data)) list = data;

          suggest.innerHTML = '';
          if (!list.length) {
            suggest.innerHTML = '<li class="ag-equipment-shipping__suggest-item is-empty">No results found</li>';
            suggest.classList.add('is-open');
            return;
          }
          list.slice(0, 20).forEach(function (item) {
            var label = itemLabel(item);
            if (!label) return;
            var li = document.createElement('li');
            li.className = 'ag-equipment-shipping__suggest-item';
            li.textContent = label;
            li.addEventListener('mousedown', function (e) {
              e.preventDefault();
              e.stopPropagation();
              applyLocation(label);
            });
            suggest.appendChild(li);
          });
          suggest.classList.add('is-open');
        })
        .catch(function () {
          hideSuggest();
        });
    }

    input.addEventListener('change', function (event) {
      event.stopPropagation();
    });
    suggest.addEventListener('mousedown', function (event) {
      event.preventDefault();
    });

    input.addEventListener('input', function () {
      var term = input.value.trim();
      resultEl.innerHTML = '';
      showError('');
      clearTimeout(debounceTimer);
      if (term.length < 2) {
        hideSuggest();
        return;
      }
      debounceTimer = setTimeout(function () {
        searchPincodes(term);
      }, 250);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      var value = input.value.trim();
      if (!value) {
        showError('Enter a valid suburb or postcode');
        return;
      }
      resolveAndEstimate(value);
    });

    submitBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var value = input.value.trim();
      if (!value) {
        showError('Enter a valid suburb or postcode');
        return;
      }
      resolveAndEstimate(value);
    });

    resultEl.innerHTML = '';
  }

  function bindBromic(root) {
    if (!root || root.dataset.bound === '1') return;
    var input = root.querySelector('.ag-equipment-shipping__input');
    var suggest = root.querySelector('.ag-equipment-shipping__suggest');
    var errorEl = root.querySelector('.ag-equipment-shipping__error');
    var resultEl = root.querySelector('.ag-equipment-shipping__result');
    var button = root.querySelector('.ag-equipment-shipping__button');
    if (!input || !suggest || !errorEl || !resultEl || !button) return;
    root.dataset.bound = '1';

    var dataUrl = root.getAttribute('data-freight-src');
    var places = null;
    var DEST = { VIC: '3', QLD: '4', SA: '5', WA: '6', TAS: '7', NT: '8' };

    function loadData(done) {
      if (window.BROMIC_FREIGHT) {
        done(window.BROMIC_FREIGHT);
        return;
      }
      if (!window.__bromicFreightWait) window.__bromicFreightWait = [];
      window.__bromicFreightWait.push(done);
      if (window.__bromicFreightLoading) return;
      window.__bromicFreightLoading = true;
      var script = document.createElement('script');
      script.src = dataUrl;
      script.onload = function () {
        var loaded = window.BROMIC_FREIGHT || null;
        var waiters = window.__bromicFreightWait || [];
        window.__bromicFreightWait = [];
        window.__bromicFreightLoading = false;
        waiters.forEach(function (fn) { fn(loaded); });
      };
      script.onerror = function () {
        var waiters = window.__bromicFreightWait || [];
        window.__bromicFreightWait = [];
        window.__bromicFreightLoading = false;
        waiters.forEach(function (fn) { fn(null); });
      };
      document.head.appendChild(script);
    }

    function rowsFor(data, postcode) {
      return ((data.locs && data.locs[postcode]) || []).map(function (row) {
        return { suburb: row[0], state: row[1], card: row[2], zone: row[3], postcode: postcode };
      });
    }

    function allPlaces(data) {
      if (places) return places;
      places = [];
      Object.keys(data.locs || {}).forEach(function (postcode) {
        rowsFor(data, postcode).forEach(function (place) { places.push(place); });
      });
      return places;
    }

    function showError(message) {
      errorEl.hidden = !message;
      errorEl.textContent = message || '';
    }

    function hideSuggest() {
      suggest.classList.remove('is-open');
      suggest.innerHTML = '';
    }

    function quantity() {
      var cartQty = lineQuantity(root);
      if (cartQty !== null) return cartQty;
      var qty = document.querySelector('.quantity-input');
      var count = qty ? parseInt(qty.value, 10) : 1;
      return isNaN(count) || count < 1 ? 1 : count;
    }

    function findPlaces(data, value) {
      var text = String(value || '').trim().toLowerCase();
      var postcode = (text.match(/\b(\d{4})\b/) || [])[1];
      if (postcode) {
        var suburbText = text.replace(postcode, '').replace(/,/g, ' ').replace(/\b(nsw|vic|qld|sa|wa|tas|nt|act)\b/g, ' ').replace(/\s+/g, ' ').trim();
        return rowsFor(data, postcode).filter(function (place) {
          if (!suburbText) return true;
          return place.suburb.toLowerCase() === suburbText || place.suburb.toLowerCase().indexOf(suburbText) !== -1;
        });
      }
      return allPlaces(data).filter(function (place) {
        return place.suburb.toLowerCase().indexOf(text) === 0;
      });
    }

    function sameZone(list) {
      return list.every(function (place) {
        return place.card === list[0].card && place.zone === list[0].zone && place.state === list[0].state;
      });
    }

    function quote(data, place) {
      var category = data.sku[root.getAttribute('data-sku') || ''];
      if (!category) return { error: 'Call us for a freight price on this model.' };
      var qty = quantity();
      var key = place.card + 'Full Service' + place.zone + category;
      if (place.state !== 'NSW' && place.state !== 'ACT' && DEST[place.state]) {
        var interstateKey = 'Interstate2' + DEST[place.state] + category;
        if (data.rates[interstateKey]) key = interstateKey;
      }
      var each = data.rates[key];
      if (!each) return { error: 'No standard rate for this suburb. Call Danny on 0452 498 755.' };
      var freight = each * qty;
      var levy = freight * data.fuel;
      var exGst = Math.round(freight + data.pallet + levy);
      return { place: place, total: Math.round(exGst * 1.1), qty: qty };
    }

    function chosenPlace(matches, value) {
      var text = String(value || '').trim().toLowerCase();
      var exact = matches.filter(function (place) {
        var label = (place.suburb + ', ' + place.state + ' ' + place.postcode).toLowerCase();
        var suburb = place.suburb.toLowerCase();
        return label === text || suburb === text;
      });
      if (exact.length === 1) return exact[0];
      if (exact.length > 1 && sameZone(exact)) return exact[0];
      if (matches.length === 1 || sameZone(matches)) return matches[0];
      return null;
    }

    function renderQuote(data, place) {
      var priced = quote(data, place);
      if (priced.error) {
        showError('');
        resultEl.innerHTML = '<p>' + priced.error + '</p>';
        return;
      }
      showError('');
      hideSuggest();
      input.value = place.suburb + ', ' + place.state + ' ' + place.postcode;
      resultEl.innerHTML =
        '<p class="ag-equipment-shipping__rate">Full service delivery — <span>including GST</span><br><strong>Delivery $' +
        priced.total + '.00</strong></p>';
    }

    function openSuggest(data, list) {
      suggest.innerHTML = '';
      list.slice(0, 8).forEach(function (place) {
        var item = document.createElement('li');
        item.className = 'ag-equipment-shipping__suggest-item';
        item.textContent = place.suburb + ', ' + place.state + ' ' + place.postcode;
          item.addEventListener('mousedown', function (event) {
            event.preventDefault();
            input.value = item.textContent;
            hideSuggest();
            resultEl.innerHTML = '';
            showError('');
          });
        suggest.appendChild(item);
      });
      if (list.length) suggest.classList.add('is-open');
    }

    function runLookup(data) {
      var matches = findPlaces(data, input.value);
      if (!matches.length) {
        showError('');
        resultEl.innerHTML = '<p>Enter a valid suburb or postcode</p>';
        return;
      }
      var place = chosenPlace(matches, input.value);
      if (!place) {
        showError('');
        resultEl.innerHTML = '<p>Choose a suburb</p>';
        openSuggest(data, matches);
        return;
      }
      renderQuote(data, place);
    }

    input.addEventListener('change', function (event) {
      event.stopPropagation();
    });
    suggest.addEventListener('mousedown', function (event) {
      event.preventDefault();
    });

    input.addEventListener('input', function () {
      var value = input.value.trim();
      resultEl.innerHTML = '';
      showError('');
      if (value.length < 2) {
        hideSuggest();
        return;
      }
      loadData(function (loaded) {
        if (!loaded) return;
        var matches = findPlaces(loaded, value);
        openSuggest(loaded, matches);
      });
    });

    input.addEventListener('blur', function () {
      setTimeout(hideSuggest, 150);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      button.click();
    });

    button.addEventListener('click', function () {
      showError('');
      resultEl.innerHTML = '<p>Calculating...</p>';
      loadData(function (loaded) {
        if (!loaded) {
          resultEl.innerHTML = '';
          showError('Freight rates did not load. Upload assets/bromic-freight-data.js with the theme.');
          return;
        }
        runLookup(loaded);
      });
    });
  }

  function initBrandShipping() {
    document.querySelectorAll('[data-brand-shipping="ag"]').forEach(bindAg);
    document.querySelectorAll('[data-brand-shipping="bromic"]').forEach(bindBromic);
  }

  window.initBrandShipping = initBrandShipping;

  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-brand-shipping="ag"] .ag-equipment-shipping__suggest.is-open').forEach(function (list) {
      var wrap = list.closest('[data-brand-shipping="ag"]');
      if (wrap && !wrap.contains(event.target)) {
        list.classList.remove('is-open');
        list.innerHTML = '';
      }
    });
  });

  function boot() {
    initBrandShipping();
    if (window.__brandShippingObserver) return;
    var queued = false;
    window.__brandShippingObserver = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        initBrandShipping();
      });
    });
    window.__brandShippingObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
